import Vue from 'vue';
export default Vue.extend({
    props: {
        block: Object
    },
    computed: {
        background: function () {
            return "block--".concat(this.block['localized']['background']);
        }
    }
});
